export default "__VITE_ASSET__Bz1Ooa0J__"